import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface RecentSearchData {
  id: number;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressType: string;
  isCustom: boolean;
  pinCode: string;
  pbdpPinCode: string | null;
  blockCode: string;
  addressCode: string;
  latitude: string;
  longitude: string;
  digiPin: string | null;
  userId: number;
  addressTypeId: number;
  createdDate: string;
  updatedDate: string;
  status: boolean;
  stateId: number | null;
  isPrivate: boolean;
  isFavourite: boolean;
  isClipped: boolean | null;
  clippedAt: string | null;
  isDeleteRequestSubmitted: boolean;
  isError: boolean | null;
  statusCode: number;
}

export const GetRecentlySearchedPamcodesAsync = async (
  fromDate: string,
  toDate: string,
  token: string
): Promise<RecentSearchData[]> => {
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/Admin/GetRecentlyAddedAddressesAsync?fromDate=${fromDate}&toDate=${toDate}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch recent search data: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in GetRecentlySearchedPamcodesAsync:', error);
    throw error;
  }
};
